import { render } from "./HomeWelcomeAudio.vue?vue&type=template&id=fa4fd5dc&scoped=true"
import script from "./HomeWelcomeAudio.vue?vue&type=script&lang=js"
export * from "./HomeWelcomeAudio.vue?vue&type=script&lang=js"

import "./HomeWelcomeAudio.vue?vue&type=style&index=0&id=fa4fd5dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa4fd5dc"]])

export default __exports__